import { render, staticRenderFns } from "./outputinvoice.vue?vue&type=template&id=83f5410e&scoped=true&"
import script from "./outputinvoice.vue?vue&type=script&lang=js&"
export * from "./outputinvoice.vue?vue&type=script&lang=js&"
import style1 from "./outputinvoice.vue?vue&type=style&index=1&id=83f5410e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f5410e",
  null
  
)

export default component.exports